import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VStepperIcon from '@/components/Templates/StepOfStepper/VStepperIcon.vue'
import VStepperStepIcon from '@/components/Templates/StepOfStepper/VStepperStepIcon.vue'

Vue.use(Vuetify,{
    components:{
        VStepperIcon,
        VStepperStepIcon
    }
});

export default new Vuetify({
    theme:{
        themes:{
            light:{
                secondary: '#036646'
            }
        }
    }
});
